export type countryType = {
  code: string
  name: string
  dial_code: number
  mask: string
}

const countries: countryType[] = [
  {
    "code": "gb",
    "name": "United Kingdom (UK)",
    "dial_code": 44,
    "mask": "+44-####-###-###",
  },
  {
    "code": "us",
    "name": "United States",
    "dial_code": 1,
    "mask": "+1(###)###-####",
  },

  {
    "code": "af",
    "name": "Afghanistan (‫افغانستان‬‎)",
    "dial_code": 93,
    "mask": "+93-##-###-####"
  },
  {
    "code": "ax",
    "name": "Aland Islands (Åland Islands)",
    "dial_code": 358,
    "mask": "358-##-#####"
  },
  {
    "code": "al",
    "name": "Albania (Shqipëri)",
    "dial_code": 355,
    "mask": "+355(###)###-###",
  },
  {
    "code": "dz",
    "name": "Algeria (‫الجزائر‬‎)",
    "dial_code": 213,
    "mask": "+213-##-###-####",
  },
  {
    "code": "as",
    "name": "American Samoa",
    "dial_code": 1684,
    "mask": "+1(684)###-####",
  },
  {
    "code": "ad",
    "name": "Andorra",
    "dial_code": 376,
    "mask": "+376-###-###",
  },
  {
    "code": "ao",
    "name": "Angola",
    "dial_code": 244,
    "mask": "+244(###)###-###",
  },
  {
    "code": "ai",
    "name": "Anguilla",
    "dial_code": 1264,
    "mask": "+1(264)###-####",
  },
  {
    "code": "ag",
    "name": "Antigua and Barbuda",
    "dial_code": 1268,
    "mask": "+1(268)###-####",
  },
  {
    "code": "ar",
    "name": "Argentina",
    "dial_code": 54,
    "mask": "+54(###)###-####",
  },
  {
    "code": "am",
    "name": "Armenia (Հայաստան)",
    "dial_code": 374,
    "mask": "+374-##-###-###",
  },
  {
    "code": "aw",
    "name": "Aruba",
    "dial_code": 297,
    "mask": "+297-###-####",
  },
  {
    "code": "au",
    "name": "Australia",
    "dial_code": 61,
    "mask": "+61-#-####-####",
  },
  {
    "code": "at",
    "name": "Austria (Österreich)",
    "dial_code": 43,
    "mask": "+43(###)###-####",
  },
  {
    "code": "az",
    "name": "Azerbaijan (Azərbaycan)",
    "dial_code": 994,
    "mask": "+994-##-###-##-##",
  },
  {
    "code": "bs",
    "name": "Bahamas",
    "dial_code": 1242,
    "mask": "+1(242)###-####",
  },
  {
    "code": "bh",
    "name": "Bahrain (‫البحرين‬‎)",
    "dial_code": 973,
    "mask": "+973-####-####",
  },
  {
    "code": "bd",
    "name": "Bangladesh (বাংলাদেশ)",
    "dial_code": 880,
    "mask": "+880-##-###-###",
  },
  {
    "code": "bb",
    "name": "Barbados",
    "dial_code": 1246,
    "mask": "+1(246)###-####",
  },
  {
    "code": "by",
    "name": "Belarus (Беларусь)",
    "dial_code": 375,
    "mask": "+375(##)###-##-##",
  },
  {
    "code": "be",
    "name": "Belgium (België)",
    "dial_code": 32,
    "mask": "+32(###)###-###",
  },
  {
    "code": "bz",
    "name": "Belize",
    "dial_code": 501,
    "mask": "+501-###-####",
  },
  {
    "code": "bj",
    "name": "Benin (Bénin)",
    "dial_code": 229,
    "mask": "+229-##-##-####",
  },
  {
    "code": "bm",
    "name": "Bermuda",
    "dial_code": 1441,
    "mask": "+1(441)###-####",
  },
  {
    "code": "bt",
    "name": "Bhutan (འབྲུག)",
    "dial_code": 975,
    "mask": "+975-#-###-###",
  },
  {
    "code": "bo",
    "name": "Bolivia",
    "dial_code": 591,
    "mask": "+591-#-###-####",
  },
  {
    "code": "ba",
    "name": "Bosnia and Herzegovina (Босна и Херцеговина)",
    "dial_code": 387,
    "mask": "+387-##-#####",
  },
  {
    "code": "bw",
    "name": "Botswana",
    "dial_code": 267,
    "mask": "+267-##-###-###",
  },
  {
    "code": "br",
    "name": "Brazil (Brasil)",
    "dial_code": 55,
    "mask": "+55(##)####-####",
  },
  {
    "code": "io",
    "name": "British Indian Ocean Territory",
    "dial_code": 246,
    "mask": "+246-###-####",
  },
  {
    "code": "vg",
    "name": "British Virgin Islands",
    "dial_code": 1284,
    "mask": "+1(284)###-####",
  },
  {
    "code": "bn",
    "name": "Brunei Darussalam",
    "dial_code": 673,
    "mask": "+673-###-####",
  },
  {
    "code": "bg",
    "name": "Bulgaria (България)",
    "dial_code": 359,
    "mask": "+359(###)###-###",
  },
  {
    "code": "bf",
    "name": "Burkina Faso",
    "dial_code": 226,
    "mask": "+226-##-##-####",
  },
  {
    "code": "bi",
    "name": "Burundi (Uburundi)",
    "dial_code": 257,
    "mask": "+257-##-##-####",
  },
  {
    "code": "kh",
    "name": "Cambodia (កម្ពុជា)",
    "dial_code": 855,
    "mask": "+855-##-###-###",
  },
  {
    "code": "cm",
    "name": "Cameroon (Cameroun)",
    "dial_code": 237,
    "mask": "+237-####-####",
  },
  {
    "code": "ca",
    "name": "Canada",
    "dial_code": 1,
    "mask": "+1(###)###-####",
  },
  {
    "code": "cv",
    "name": "Cape Verde (Kabu Verdi)",
    "dial_code": 238,
    "mask": "+238(###)##-##",
  },
  {
    "code": "bq",
    "name": "Caribbean Netherlands",
    "dial_code": 599,
    "mask": "+599-###-####"
  },
  {
    "code": "ky",
    "name": "Cayman Islands",
    "dial_code": 1345,
    "mask": "+1(345)###-####",
  },
  {
    "code": "cf",
    "name": "Central African Republic (République centrafricaine)",
    "dial_code": 236,
    "mask": "+236-##-##-####",
  },
  {
    "code": "td",
    "name": "Chad (Tchad)",
    "dial_code": 235,
    "mask": "+235-##-##-##-##",
  },
  {
    "code": "cl",
    "name": "Chile",
    "dial_code": 56,
    "mask": "+56-#-####-####",
  },
  {
    "code": "cn",
    "name": "China (中国)",
    "dial_code": 86,
    "mask": "+86-##-#####-#####",
  },
  {
    "code": "cx",
    "name": "Christmas Island",
    "dial_code": 61,
    "mask": "61-#-####-####"
  },
  {
    "code": "cc",
    "name": "Cocos (Keeling) Islands",
    "dial_code": 61,
    "mask": "61-#-####-####"
  },
  {
    "code": "co",
    "name": "Colombia",
    "dial_code": 57,
    "mask": "+57(###)###-####",
  },
  {
    "code": "km",
    "name": "Comoros (‫جزر القمر‬‎)",
    "dial_code": 269,
    "mask": "+269-##-#####",
  },
  {
    "code": "cd",
    "name": "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    "dial_code": 243,
    "mask": "+243(###)###-###",
  },
  {
    "code": "cg",
    "name": "Congo (Republic) (Congo-Brazzaville)",
    "dial_code": 242,
    "mask": "+242-##-###-####",
  },
  {
    "code": "ck",
    "name": "Cook Islands",
    "dial_code": 682,
    "mask": "+682-##-###",
  },
  {
    "code": "cr",
    "name": "Costa Rica",
    "dial_code": 506,
    "mask": "+506-####-####",
  },
  {
    "code": "ci",
    "name": "Côte d’Ivoire",
    "dial_code": 225,
    "mask": "+225-##-###-###",
  },
  {
    "code": "hr",
    "name": "Croatia (Hrvatska)",
    "dial_code": 385,
    "mask": "+385-##-###-###",
  },
  {
    "code": "cu",
    "name": "Cuba",
    "dial_code": 53,
    "mask": "+53-#-###-####",
  },
  {
    "code": "cw",
    "name": "Curaçao",
    "dial_code": 599,
    "mask": "+599-###-####",
  },
  {
    "code": "cy",
    "name": "Cyprus (Κύπρος)",
    "dial_code": 357,
    "mask": "+357-##-###-###",
  },
  {
    "code": "cz",
    "name": "Czech Republic (Česká republika)",
    "dial_code": 420,
    "mask": "+420(###)###-###",
  },
  {
    "code": "dk",
    "name": "Denmark",
    "dial_code": 45,
    "mask": "+45-##-##-##-##",
  },
  {
    "code": "dj",
    "name": "Djibouti",
    "dial_code": 253,
    "mask": "+253-##-##-##-##",
  },
  {
    "code": "dm",
    "name": "Dominica",
    "dial_code": 1767,
    "mask": "+1(767)###-####",
  },
  {
    "code": "do",
    "name": "Dominican Republic",
    "dial_code": 1,
    "mask": "+1(809)###-####",
  },
  {
    "code": "ec",
    "name": "Ecuador",
    "dial_code": 593,
    "mask": "+593-##-###-####",
  },
  {
    "code": "eg",
    "name": "Egypt (‫مصر‬‎)",
    "dial_code": 20,
    "mask": "+20(###)###-####",
  },
  {
    "code": "sv",
    "name": "El Salvador",
    "dial_code": 503,
    "mask": "+503-##-##-####",
  },
  {
    "code": "gq",
    "name": "Equatorial Guinea (Guinea Ecuatorial)",
    "dial_code": 240,
    "mask": "+240-##-###-####",
  },
  {
    "code": "er",
    "name": "Eritrea",
    "dial_code": 291,
    "mask": "+291-#-###-###",
  },
  {
    "code": "ee",
    "name": "Estonia (Eesti)",
    "dial_code": 372,
    "mask": "+372-####-####",
  },
  {
    "code": "et",
    "name": "Ethiopia",
    "dial_code": 251,
    "mask": "+251-##-###-####",
  },
  {
    "code": "fk",
    "name": "Falkland Islands (Islas Malvinas)",
    "dial_code": 500,
    "mask": "+500-#####",
  },
  {
    "code": "fo",
    "name": "Faroe Islands (Føroyar)",
    "dial_code": 298,
    "mask": "+298-###-###",
  },
  {
    "code": "fj",
    "name": "Fiji",
    "dial_code": 679,
    "mask": "+679-##-#####",
  },
  {
    "code": "fi",
    "name": "Finland (Suomi)",
    "dial_code": 358,
    "mask": "+358(###)###-##-##",
  },
  {
    "code": "fr",
    "name": "France",
    "dial_code": 33,
    "mask": "+33(###)###-###",
  },
  {
    "code": "gf",
    "name": "French Guiana (Guyane française)",
    "dial_code": 594,
    "mask": "+594-#####-####",
  },
  {
    "code": "pf",
    "name": "French Polynesia (Polynésie française)",
    "dial_code": 689,
    "mask": "+689-##-##-##",
  },
  {
    "code": "ga",
    "name": "Gabon",
    "dial_code": 241,
    "mask": "+241-#-##-##-##",
  },
  {
    "code": "gm",
    "name": "Gambia",
    "dial_code": 220,
    "mask": "+220(###)##-##",
  },
  {
    "code": "ge",
    "name": "Georgia (საქართველო)",
    "dial_code": 995,
    "mask": "+995(###)###-###",
  },
  {
    "code": "de",
    "name": "Germany (Deutschland)",
    "dial_code": 49,
    "mask": "+49(####)###-####",
  },
  {
    "code": "gh",
    "name": "Ghana (Gaana)",
    "dial_code": 233,
    "mask": "+233(###)###-###",
  },
  {
    "code": "gi",
    "name": "Gibraltar",
    "dial_code": 350,
    "mask": "+350-###-#####",
  },
  {
    "code": "gr",
    "name": "Greece (Ελλάδα)",
    "dial_code": 30,
    "mask": "+30(###)###-####",
  },
  {
    "code": "gl",
    "name": "Greenland (Kalaallit Nunaat)",
    "dial_code": 299,
    "mask": "+299-##-##-##",
  },
  {
    "code": "gd",
    "name": "Grenada",
    "dial_code": 1473,
    "mask": "+1(473)###-####",
  },
  {
    "code": "gp",
    "name": "Guadeloupe",
    "dial_code": 590,
    "mask": "+590-###-##-##-##",
  },
  {
    "code": "gu",
    "name": "Guam",
    "dial_code": 1671,
    "mask": "+1(671)###-####",
  },
  {
    "code": "gt",
    "name": "Guatemala",
    "dial_code": 502,
    "mask": "+502-#-###-####",
  },
  {
    "code": "gg",
    "name": "Guernsey",
    "dial_code": 44,
    "mask": "+44-####-######"
  },
  {
    "code": "gn",
    "name": "Guinea (Guinée)",
    "dial_code": 224,
    "mask": "+224-##-###-###",
  },
  {
    "code": "gw",
    "name": "Guinea Bissau (Guiné Bissau)",
    "dial_code": 245,
    "mask": "+245-#-######",
  },
  {
    "code": "gy",
    "name": "Guyana",
    "dial_code": 592,
    "mask": "+592-###-####",
  },
  {
    "code": "ht",
    "name": "Haiti",
    "dial_code": 509,
    "mask": "+509-##-##-####",
  },
  {
    "code": "hn",
    "name": "Honduras",
    "dial_code": 504,
    "mask": "+504-####-####",
  },
  {
    "code": "hk",
    "name": "Hong Kong (香港)",
    "dial_code": 852,
    "mask": "+852-####-####",
  },
  {
    "code": "hu",
    "name": "Hungary (Magyarország)",
    "dial_code": 36,
    "mask": "+36(###)###-###",
  },
  {
    "code": "is",
    "name": "Iceland (Ísland)",
    "dial_code": 354,
    "mask": "+354-###-####",
  },
  {
    "code": "in",
    "name": "India (भारत)",
    "dial_code": 91,
    "mask": "+91(####)###-###",
  },
  {
    "code": "id",
    "name": "Indonesia",
    "dial_code": 62,
    "mask": "+62(8##)###-####",
  },
  {
    "code": "ir",
    "name": "Iran (‫ایران‬‎)",
    "dial_code": 98,
    "mask": "+98(###)###-####",
  },
  {
    "code": "iq",
    "name": "Iraq (‫العراق‬‎)",
    "dial_code": 964,
    "mask": "+964(###)###-####",
  },
  {
    "code": "ie",
    "name": "Ireland",
    "dial_code": 353,
    "mask":  "+353(###)###-###",
  },
  {
    "code": "im",
    "name": "Isle of Man",
    "dial_code": 44,
    "mask": "+44-####"
  },
  {
    "code": "il",
    "name": "Israel (‫ישראל‬‎)",
    "dial_code": 972,
    "mask": "+972-#-###-####",
  },
  {
    "code": "it",
    "name": "Italy (Italia)",
    "dial_code": 39,
    "mask": "+39(###)####-###",
  },
  {
    "code": "jm",
    "name": "Jamaica",
    "dial_code": 1876,
    "mask": "+1(876)###-####",
  },
  {
    "code": "jp",
    "name": "Japan (日本)",
    "dial_code": 81,
    "mask": "+81-##-####-####",
  },
  {
    "code": "je",
    "name": "Jersey",
    "dial_code": 44,
    "mask": "+44-##########"
  },
  {
    "code": "jo",
    "name": "Jordan (‫الأردن‬‎)",
    "dial_code": 962,
    "mask": "+962-#-####-####",
  },
  {
    "code": "kz",
    "name": "Kazakhstan (Казахстан)",
    "dial_code": 7,
    "mask": "+7(###)###-##-##",
  },
  {
    "code": "ke",
    "name": "Kenya",
    "dial_code": 254,
    "mask": "+254-###-######",
  },
  {
    "code": "ki",
    "name": "Kiribati",
    "dial_code": 686,
    "mask": "+686-##-###",
  },
  {
    "code": "xk",
    "name": "Kosovo",
    "dial_code": 383,
    "mask": "+383-########"
  },
  {
    "code": "kw",
    "name": "Kuwait (‫الكويت‬‎)",
    "dial_code": 965,
    "mask": "+965-####-####",
  },
  {
    "code": "kg",
    "name": "Kyrgyzstan (Кыргызстан)",
    "dial_code": 996,
    "mask": "+996(###)###-###",
  },
  {
    "code": "la",
    "name": "Laos (ລາວ)",
    "dial_code": 856,
    "mask": "+856(20##)###-###",
  },
  {
    "code": "lv",
    "name": "Latvia (Latvija)",
    "dial_code": 371,
    "mask": "+371-##-###-###",
  },
  {
    "code": "lb",
    "name": "Lebanon (‫لبنان‬‎)",
    "dial_code": 961,
    "mask":  "+961-##-###-###",
  },
  {
    "code": "ls",
    "name": "Lesotho",
    "dial_code": 266,
    "mask": "+266-#-###-####",
  },
  {
    "code": "lr",
    "name": "Liberia",
    "dial_code": 231,
    "mask": "+231-##-###-###",
  },
  {
    "code": "ly",
    "name": "Libya (‫ليبيا‬‎)",
    "dial_code": 218,
    "mask": "+218-##-###-###",
  },
  {
    "code": "li",
    "name": "Liechtenstein",
    "dial_code": 423,
    "mask": "+423(###)###-####",
  },
  {
    "code": "lt",
    "name": "Lithuania (Lietuva)",
    "dial_code": 370,
    "mask": "+370(###)##-###",
  },
  {
    "code": "lu",
    "name": "Luxembourg",
    "dial_code": 352,
    "mask": "+352(###)###-###",
  },
  {
    "code": "mo",
    "name": "Macao (澳門)",
    "dial_code": 853,
    "mask": "+853-####-####",
  },
  {
    "code": "mk",
    "name": "Macedonia (FYROM) (Македонија)",
    "dial_code": 389,
    "mask": "+389-##-###-###",
  },
  {
    "code": "mg",
    "name": "Madagascar (Madagasikara)",
    "dial_code": 261,
    "mask": "+261-##-##-#####",
  },
  {
    "code": "mw",
    "name": "Malawi",
    "dial_code": 265,
    "mask": "+265-1-###-###",
  },
  {
    "code": "my",
    "name": "Malaysia",
    "dial_code": 60,
    "mask": "+60-##-###-####",
  },
  {
    "code": "mv",
    "name": "Maldives",
    "dial_code": 960,
    "mask": "+960-###-####",
  },
  {
    "code": "ml",
    "name": "Mali",
    "dial_code": 223,
    "mask": "+223-##-##-####",
  },
  {
    "code": "mt",
    "name": "Malta",
    "dial_code": 356,
    "mask": "+356-####-####",
  },
  {
    "code": "mh",
    "name": "Marshall Islands",
    "dial_code": 692,
    "mask": "+692-###-####",
  },
  {
    "code": "mq",
    "name": "Martinique",
    "dial_code": 596,
    "mask": "+596(###)##-##-##",
  },
  {
    "code": "mr",
    "name": "Mauritania (‫موريتانيا‬‎)",
    "dial_code": 222,
    "mask": "+222-##-##-####",
  },
  {
    "code": "mu",
    "name": "Mauritius (Moris)",
    "dial_code": 230,
    "mask": "+230-###-####",
  },
  {
    "code": "yt",
    "name": "Mayotte",
    "dial_code": 262,
    "mask": "+262-###-#######"
  },
  {
    "code": "mx",
    "name": "Mexico (México)",
    "dial_code": 52,
    "mask": "+52(###)###-####",
  },
  {
    "code": "fm",
    "name": "Micronesia",
    "dial_code": 691,
    "mask": "+691-###-####",
  },
  {
    "code": "md",
    "name": "Moldova (Republica Moldova)",
    "dial_code": 373,
    "mask": "+373-####-####",
  },
  {
    "code": "mc",
    "name": "Monaco",
    "dial_code": 377,
    "mask": "+377(###)###-###",
  },
  {
    "code": "mn",
    "name": "Mongolia (Монгол)",
    "dial_code": 976,
    "mask":  "+976-##-##-####",
  },
  {
    "code": "me",
    "name": "Montenegro (Crna Gora)",
    "dial_code": 382,
    "mask": "+382-##-###-###",
  },
  {
    "code": "ms",
    "name": "Montserrat",
    "dial_code": 1664,
    "mask": "+1(664)###-####",
  },
  {
    "code": "ma",
    "name": "Morocco (‫المغرب‬‎)",
    "dial_code": 212,
    "mask": "+212-##-####-###",
  },
  {
    "code": "mz",
    "name": "Mozambique (Moçambique)",
    "dial_code": 258,
    "mask": "+258-##-###-###",
  },
  {
    "code": "mm",
    "name": "Myanmar (Burma) (မြန်မာ)",
    "dial_code": 95,
    "mask": "+95-##-###-###",
  },
  {
    "code": "na",
    "name": "Namibia (Namibië)",
    "dial_code": 264,
    "mask": "+264-##-###-####",
  },
  {
    "code": "nr",
    "name": "Nauru",
    "dial_code": 674,
    "mask": "+674-###-####",
  },
  {
    "code": "np",
    "name": "Nepal (नेपाल)",
    "dial_code": 977,
    "mask": "+977-##-###-###",
  },
  {
    "code": "nl",
    "name": "Netherlands (Nederland)",
    "dial_code": 31,
    "mask": "+31-##-###-####",
  },
  {
    "code": "nc",
    "name": "New Caledonia (Nouvelle-Calédonie)",
    "dial_code": 687,
    "mask": "+687-##-####",
  },
  {
    "code": "nz",
    "name": "New Zealand",
    "dial_code": 64,
    "mask":  "+64(###)###-###",
  },
  {
    "code": "ni",
    "name": "Nicaragua",
    "dial_code": 505,
    "mask": "+505-####-####",
  },
  {
    "code": "ne",
    "name": "Niger (Nijar)",
    "dial_code": 227,
    "mask": "+227-##-##-####",
  },
  {
    "code": "ng",
    "name": "Nigeria",
    "dial_code": 234,
    "mask": "+234(###)###-####",
  },
  {
    "code": "nu",
    "name": "Niue",
    "dial_code": 683,
    "mask": "+683-####",
  },
  {
    "code": "nf",
    "name": "Norfolk Island",
    "dial_code": 672,
    "mask": "+672-3##-###",
  },
  {
    "code": "kp",
    "name": "North Korea (조선 민주주의 인민 공화국)",
    "dial_code": 850,
    "mask": "+850-###-###-####",
  },
  // {
  //   "code": "mk",
  //   "name": "North Macedonia",
  //   "dial_code": "Europe"
  // },
  {
    "code": "mp",
    "name": "Northern Mariana Islands",
    "dial_code": 1670,
    "mask": "+1(670)###-####",
  },
  {
    "code": "no",
    "name": "Norway (Norge)",
    "dial_code": 47,
    "mask": "+47(###)##-###",
  },
  {
    "code": "om",
    "name": "Oman (‫عُمان‬‎)",
    "dial_code": 968,
    "mask": "+968-##-###-###",
  },
  {
    "code": "pk",
    "name": "Pakistan (‫پاکستان‬‎)",
    "dial_code": 92,
    "mask": "+92(###)###-####",
  },
  {
    "code": "pw",
    "name": "Palau",
    "dial_code": 680,
    "mask": "+680-###-####",
  },
  {
    "code": "ps",
    "name": "Palestine (‫فلسطين‬‎)",
    "dial_code": 970,
    "mask": "+970-##-###-####",
  },
  {
    "code": "pa",
    "name": "Panama (Panamá)",
    "dial_code": 507,
    "mask": "+507-###-####",
  },
  {
    "code": "pg",
    "name": "Papua New Guinea",
    "dial_code": 675,
    "mask": "+675(###)##-###",
  },
  {
    "code": "py",
    "name": "Paraguay",
    "dial_code": 595,
    "mask": "+595(###)###-###",
  },
  {
    "code": "pe",
    "name": "Peru (Perú)",
    "dial_code": 51,
    "mask": "+51(###)###-###",
  },
  {
    "code": "ph",
    "name": "Philippines",
    "dial_code": 63,
    "mask": "+63(###)###-####",
  },
  {
    "code": "pl",
    "name": "Poland (Polska)",
    "dial_code": 48,
    "mask": "+48(###)###-###",
  },
  {
    "code": "pt",
    "name": "Portugal",
    "dial_code": 351,
    "mask": "+351-##-###-####",
  },
  {
    "code": "pr",
    "name": "Puerto Rico",
    "dial_code": 1,
    "mask": "+1-###-###-####"
  },
  {
    "code": "qa",
    "name": "Qatar (‫قطر‬‎)",
    "dial_code": 974,
    "mask": "+974-####-####",
  },
  {
    "code": "re",
    "name": "Réunion (La Réunion)",
    "dial_code": 262,
    "mask": "+262-#####-####",
  },
  {
    "code": "ro",
    "name": "Romania (România)",
    "dial_code": 40,
    "mask": "+40-##-###-####",
  },
  {
    "code": "ru",
    "name": "Russia (Россия)",
    "dial_code": 7,
    "mask": "+7(###)###-##-##",
  },
  {
    "code": "rw",
    "name": "Rwanda",
    "dial_code": 250,
    "mask": "+250(###)###-###",
  },
  {
    "code": "bl",
    "name": "Saint Barthélemy",
    "dial_code": 590,
    "mask": "+590-###-######"
  },
  {
    "code": "sh",
    "name": "Saint Helena",
    "dial_code": 290,
    "mask": "+290-####",
  },
  {
    "code": "kn",
    "name": "Saint Kitts and Nevis",
    "dial_code": 1869,
    "mask": "+1(869)###-####",
  },
  {
    "code": "lc",
    "name": "Saint Lucia",
    "dial_code": 1758,
    "mask": "+1(758)###-####",
  },
  {
    "code": "mf",
    "name": "Saint Martin (Saint-Martin (partie française))",
    "dial_code": 590,
    "mask": "+590-###-##-##-##"
  },
  {
    "code": "pm",
    "name": "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    "dial_code": 508,
    "mask": "+508-######"
  },
  {
    "code": "vc",
    "name": "Saint Vincent and the Grenadines",
    "dial_code": 1784,
    "mask": "+1(784)###-####",
  },
  {
    "code": "ws",
    "name": "Samoa",
    "dial_code": 685,
    "mask": "+685-##-####",
  },
  {
    "code": "sm",
    "name": "San Marino",
    "dial_code": 378,
    "mask": "+378-####-######",
  },
  {
    "code": "st",
    "name": "São Tomé and Príncipe (São Tomé e Príncipe)",
    "dial_code": 239,
    "mask": "+239-##-#####",
  },
  {
    "code": "sa",
    "name": "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    "dial_code": 966,
    "mask": "+966-5-####-####",
  },
  {
    "code": "sn",
    "name": "Senegal (Sénégal)",
    "dial_code": 221,
    "mask": "+221-##-###-####",
  },
  {
    "code": "rs",
    "name": "Serbia (Србија)",
    "dial_code": 381,
    "mask": "+381-##-###-####",
  },
  {
    "code": "sc",
    "name": "Seychelles",
    "dial_code": 248,
    "mask": "+248-#-###-###",
  },
  {
    "code": "sl",
    "name": "Sierra Leone",
    "dial_code": 232,
    "mask": "+232-##-######",
  },
  {
    "code": "sg",
    "name": "Singapore",
    "dial_code": 65,
    "mask": "+65-####-####",
  },
  {
    "code": "sk",
    "name": "Slovakia (Slovensko)",
    "dial_code": 421,
    "mask": "+421(###)###-###",
  },
  {
    "code": "si",
    "name": "Slovenia (Slovenija)",
    "dial_code": 386,
    "mask": "+386-##-###-###",
  },
  {
    "code": "sb",
    "name": "Solomon Islands",
    "dial_code": 677,
    "mask": "+677-###-####",
  },
  {
    "code": "so",
    "name": "Somalia (Soomaaliya)",
    "dial_code": 252,
    "mask": "+252-##-###-###",
  },
  {
    "code": "za",
    "name": "South Africa",
    "dial_code": 27,
    "mask": "+27-##-###-####",
  },
  {
    "code": "kr",
    "name": "South Korea (대한민국)",
    "dial_code": 82,
    "mask": "+82-##-###-####",
  },
  {
    "code": "ss",
    "name": "South Sudan (‫جنوب السودان‬‎)",
    "dial_code": 211,
    "mask": "+211-##-###-####",
  },
  {
    "code": "es",
    "name": "Spain (España)",
    "dial_code": 34,
    "mask": "+34(###)###-###",
  },
  {
    "code": "lk",
    "name": "Sri Lanka (ශ්‍රී ලංකාව)",
    "dial_code": 94,
    "mask": "+94-##-###-####",
  },
  {
    "code": "sd",
    "name": "Sudan (‫السودان‬‎)",
    "dial_code": 249,
    "mask": "+249-##-###-####",
  },
  {
    "code": "sr",
    "name": "Suriname",
    "dial_code": 597,
    "mask": "+597-###-####",
  },
  {
    "code": "sj",
    "name": "Svalbard and Jan Mayen",
    "dial_code": 47,
    "mask": "+47-##-##-##-##"
  },
  {
    "code": "sz",
    "name": "Swaziland",
    "dial_code": 268,
    "mask": "+268-##-##-####",
  },
  {
    "code": "se",
    "name": "Sweden (Sverige)",
    "dial_code": 46,
    "mask": "+46-##-###-####",
  },
  {
    "code": "ch",
    "name": "Switzerland (Schweiz)",
    "dial_code": 41,
    "mask": "+41-##-###-####",
  },
  {
    "code": "sy",
    "name": "Syria (‫سوريا‬‎)",
    "dial_code": 963,
    "mask": "+963-##-####-###",
  },
  {
    "code": "tw",
    "name": "Taiwan (台灣)",
    "dial_code": 886,
    "mask": "+886-#-####-####",
  },
  {
    "code": "tj",
    "name": "Tajikistan",
    "dial_code": 992,
    "mask": "+992-##-###-####",
  },
  {
    "code": "tz",
    "name": "Tanzania",
    "dial_code": 255,
    "mask": "+255-##-###-####",
  },
  {
    "code": "th",
    "name": "Thailand (ไทย)",
    "dial_code": 66,
    "mask": "+66-##-###-####",
  },
  {
    "code": "tl",
    "name": "Timor-Leste",
    "dial_code": 670,
    "mask":  "+670-###-####",
  },
  {
    "code": "tg",
    "name": "Togo",
    "dial_code": 228,
    "mask": "+228-##-###-###",
  },
  {
    "code": "tk",
    "name": "Tokelau",
    "dial_code": 690,
    "mask": "+690-####",
  },
  {
    "code": "to",
    "name": "Tonga",
    "dial_code": 676,
    "mask": "+676-#####",
  },
  {
    "code": "tt",
    "name": "Trinidad and Tobago",
    "dial_code": 1868,
    "mask": "+1(868)###-####",
  },
  {
    "code": "tn",
    "name": "Tunisia (‫تونس‬‎)",
    "dial_code": 216,
    "mask": "+216-##-###-###",
  },
  {
    "code": "tr",
    "name": "Turkey (Türkiye)",
    "dial_code": 90,
    "mask": "+90(###)###-####",
  },
  {
    "code": "tm",
    "name": "Turkmenistan",
    "dial_code": 993,
    "mask": "+993-#-###-####",
  },
  {
    "code": "tc",
    "name": "Turks and Caicos Islands",
    "dial_code": 1649,
    "mask": "+1(649)###-####",
  },
  {
    "code": "tv",
    "name": "Tuvalu",
    "dial_code": 688,
    "mask": "+688-90####",
  },
  {
    "code": "ug",
    "name": "Uganda",
    "dial_code": 256,
    "mask": "+256(###)###-###",
  },
  {
    "code": "ua",
    "name": "Ukraine (Україна)",
    "dial_code": 380,
    "mask": "+380(##)###-##-##",
  },
  {
    "code": "ae",
    "name": "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    "dial_code": 971,
    "mask": "+971-#-###-####",
  },
  {
    "code": "vi",
    "name": "United States Virgin Islands",
    "dial_code": 1340,
    "mask": "+1(340)###-####",
  },
  {
    "code": "uy",
    "name": "Uruguay",
    "dial_code": 598,
    "mask": "+598-#-###-##-##",
  },
  {
    "code": "uz",
    "name": "Uzbekistan (Oʻzbekiston)",
    "dial_code": 998,
    "mask": "+998-##-###-####",
  },
  {
    "code": "vu",
    "name": "Vanuatu",
    "dial_code": 678,
    "mask": "+678-##-#####",
  },
  {
    "code": "va",
    "name": "Vatican City (Città del Vaticano)",
    "dial_code": 39,
    "mask": "+39-6-698-#####",
  },
  {
    "code": "ve",
    "name": "Venezuela",
    "dial_code": 58,
    "mask": "+58(###)###-####",
  },
  {
    "code": "vn",
    "name": "Vietnam (Việt Nam)",
    "dial_code": 84,
    "mask": "+84-##-####-###",
  },
  {
    "code": "wf",
    "name": "Wallis and Futuna (Wallis-et-Futuna)",
    "dial_code": 681,
    "mask": "+681-##-####",
  },
  {
    "code": "eh",
    "name": "Western Sahara (‫الصحراء الغربية‬‎)",
    "dial_code": 212,
    "mask": "+212-#########"
  },
  {
    "code": "ye",
    "name": "Yemen (‫اليمن‬‎)",
    "dial_code": 967,
    "mask": "+967-#-###-###",
  },
  {
    "code": "zm",
    "name": "Zambia",
    "dial_code": 260,
    "mask": "+260-##-###-####",
  },
  {
    "code": "zw",
    "name": "Zimbabwe",
    "dial_code": 263,
    "mask": "+263-#-######",
  }
]

export default countries;
